import React, {useEffect, useState} from 'react';
import Header from '../Header';
import RankingRow from './RankingRow';
import {useLocation, useHistory} from 'react-router-dom';
import styles from './ChallengeLeaderboard.module.css';
import {rwbApi} from '../../../../shared/apis/api';
import Loading from '../Loading';
import { projectConfig } from '../../../../shared/project-info/projectConfig';

const ChallengeLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.state.rank > 10) { // in CA, the backend returns a top ten on the initial challenge view, instead of 25.
      setIsLoading(true);
      rwbApi
        .getLeaderboardCentered(location.state.challengeId)
        .then((res) => {
          setLeaderboard(res);
          setIsLoading(false);
        })
        .catch((err) => {
          console.warn(projectConfig.name, 'Error Loading Leaderboard Centered 25');
          setIsLoading(false);
        });
    } else {
      setLeaderboard(location.state.data);
    }
  }, []);

  return (
    <>
      {isLoading && (
        <Loading size={100} color={'var(--white)'} loading={isLoading} right />
      )}
      <Header
        title={'Leaderboard'}
        subtitle={location.state.challengeName}
        onBack={history.goBack}
      />
      <div className={styles.leaderboardContainer}>
        {leaderboard.map((ranker, index) => {
          return (
            <RankingRow
              key={`ranked-row-${index}`}
              place={ranker.rank}
              user={ranker.user}
              progress={ranker.score}
              metric={location.state.metric}
            />
          );
        })}
      </div>
    </>
  );
};

export default ChallengeLeaderboard;
